import 'react-native-gesture-handler';
import { StatusBar } from "expo-status-bar";
import { SafeAreaProvider } from "react-native-safe-area-context";

import useCachedResources from "./hooks/useCachedResources";
import useColorScheme from "./hooks/useColorScheme";
import Navigation from "./navigation";
import { Text } from "react-native";
// Cognito - Auth

//// DO NOT USE THIS BLOCK.  USE aws-amplify-react-native instead of @aws-amplify/ui-react-native.
//// UNINSTALL @aws-amplify/ui-react-native
// import {
//   useAuthenticator,
//   withAuthenticator,
// } from "@aws-amplify/ui-react-native";

import { withAuthenticator } from "aws-amplify-react-native";

import { Amplify, Auth, Hub, Analytics, graphqlOperation } from "aws-amplify";
Analytics.disable();

import awsconfig from "./aws-exports";
Amplify.configure(awsconfig);

async function signUp() {
  try {
    const { user } = await Auth.signUp({
      username,
      password,
      attributes: {
        email, // optional
        phone_number, // optional - E.164 number convention
        // other custom attributes
      },
      autoSignIn: {
        // optional - enables auto sign in after user is confirmed
        enabled: true,
      },
    });
    console.log(user);
  } catch (error) {
    console.log("error signing up:", error);
  }
}

async function resendConfirmationCode() {
  try {
    await Auth.resendSignUp(username);
    console.log("code resent successfully");
  } catch (err) {
    console.log("error resending code: ", err);
  }
}

async function confirmSignUp() {
  try {
    await Auth.confirmSignUp(username, code, { forceAliasCreation: false });
  } catch (error) {
    console.log("error confirming sign up", error);
  }
}

function listenToAutoSignInEvent() {
  Hub.listen("auth", ({ payload }) => {
    const { event } = payload;
    if (event === "autoSignIn") {
      const user = payload.data;
      // assign user
    } else if (event === "autoSignIn_failure") {
      // redirect to sign in page
    }
  });
}

async function signIn() {
  try {
    const user = await Auth.signIn(username, password);
  } catch (error) {
    console.log("error signing in", error);
  }
}

async function signOut() {
  try {
    await Auth.signOut({ global: true });
  } catch (error) {
    console.log("error signing out: ", error);
  }
}

async function getUserInfo() {
  const user = await Auth.currentAuthenticatedUser();
  console.log("attributes:", user.attributes);
}

// App
// export default function App() {
function App() {
  const isLoadingComplete = useCachedResources();
  const colorScheme = useColorScheme();

  if (!isLoadingComplete) {
    return null;
  } else {
    return (
      <SafeAreaProvider>
        <Navigation colorScheme={colorScheme} />
        <StatusBar />
      </SafeAreaProvider>
    );
  }
}

export default withAuthenticator(App, false);
// "true" means to show the signout button
